import { render, staticRenderFns } from "./allTarefeList.vue?vue&type=template&id=04c83b3b&scoped=true"
import script from "./allTarefeList.vue?vue&type=script&lang=js"
export * from "./allTarefeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c83b3b",
  null
  
)

export default component.exports